<template>
  <div class="aside-page">
    <div class="logo">
      <router-link to="/index">
        <el-image :src="require('@assets/img/logo.png')" :fit="isCollapse ? 'contain' : 'contain'">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </router-link>
    </div>
    <div class="ai-menu">
      <el-menu unique-opened router class="el-menu-vertical-demo" :collapse="isCollapse" :collapse-transition="false"
               :default-active="indexPage" ref="aiMenu" @select="refresh">
        <menu-item v-for="(item, index) in menuList" :key="index" :routeObj="item"></menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import MenuItem from "./components/MenuItem"
  import {getPermissionRoutes} from '@router/permission'
  export default {
    name: "AsidePage",
    inject: ['reload'],
    components: {MenuItem},
    data() {
      return {
        indexPage: "",
        menuList: []
      }
    },
    computed: {
      ...mapGetters([
        'isCollapse'
      ])
    },
    watch: {
      $route(to) {
        this.indexPage = to.path;
      }
    },
    methods: {
      refresh (path) {
        document.body.clientWidth <= 1050 && this.$store.commit("switchCollapse");
        if (path === this.$route.path) {
          // 刷新view
          this.reload();
        }
      }
    },
    created() {
      this.menuList = getPermissionRoutes(this.$store.state.permissions);
      this.indexPage = this.$router.history.current.path || "";
    }
  }
</script>

<style lang="scss">
  .aside-page {
    z-index: 99;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: $aside-width;
    background-color: $aside-color;
    overflow: hidden;
    transition: $menu-transition;
    display: flex;
    flex-direction: column;
    .collapse & {
      width: $aside-width-collapse;
      .ai-menu {
        width: $aside-width-collapse + 20;
      }
      .logo {
        padding: 0 5px;
      }
    }
    .logo {
      height: $header-height - 1;
      transition: $menu-transition;
      cursor: pointer;
      background-color: $aside-color;
      padding: 0 10px;
      a {
        display: inline-block;
        width: 100%;
        height: 100%;
        .el-image {
          width: 100%;
          height: 100%;
          .el-image__placeholder {
            background-color: $aside-color;
          }
          .image-slot {
            height: 100%;
            color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 30px;
          }
        }
      }
    }
    .ai-menu {
      width: $aside-width + 20;
      flex: 1;
      overflow-x: hidden;
      overflow-y: auto;
      transition: all 0.3s ease 0s;
    }
    .el-menu-vertical-demo {
      width: $aside-width;
      border: none;
      transition: 0s;
      background-color: transparent;
      &.el-menu--collapse {
        width: $aside-width-collapse;
        transition: $menu-transition;
        .el-submenu {
          .el-submenu__title {
            span {
              height: 0;
              width: 0;
              overflow: hidden;
              visibility: hidden;
              display: inline-block;
            }
            .el-submenu__icon-arrow {
              display: none;
            }
          }
        }
      }
      .el-menu-item {
        height: $aside-item-height;
        line-height: $aside-item-height;
        color: $aside-font-color;
        background-color: transparent;
        i {
          transition: $aside-color-transition;
          color: $aside-font-color;
        }
        &:hover {
          background-color: $aside-hover-color!important;
        }
        &.is-active {
          color: $aside-title-font-color;
          &:before {
            content: "";
            position: absolute;
            margin: 4% 0;
            top: 0;
            bottom: 0;
            left: 0;
            width: 2px;
            background-color: $aside-title-font-color;
          }
          i {
            color: $aside-title-font-color;
          }
        }
      }
      .el-submenu {
        .el-submenu__title {
          height: $aside-item-height;
          line-height: $aside-item-height;
          color: $aside-font-color;
          background-color:$aside-color;
          i {
            transition: $aside-color-transition;
            color: $aside-font-color;
          }
          &:hover {
            background-color: $aside-hover-color!important;
          }
        }
        &.is-active {
          .el-submenu__title {
            color: $aside-title-font-color;
          }
          i {
            color: $aside-title-font-color;
          }
        }
        .el-menu {
          background-color: $aside-item-color;
          .el-menu-item {
            &:hover {
              background-color: $aside-item-hover-color!important;
            }
          }
        }
      }
    }
  }
</style>
